import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import { withRouter } from "react-router-dom";

import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

import LookCanvasContext from "../../../lookCanvasContext";
import {zoomCanvasOut} from "../../lookFunctions";
import {setCanvasScale} from "../../../../../actions/actionFunctions";
import {getLookIdUrl} from "../../lookFunctions2";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";


const LookWizardHeaderTitleAndBackButton = (props) => {

  const {intl, history, isMobile, setCanvasScale, title} = props;

  const backButtonClick = (imageCanvas) => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookMenuHeaderBack);
    zoomCanvasOut(imageCanvas, setCanvasScale);
    history.push(getLookIdUrl());
  };

  return (
    <LookCanvasContext.Consumer>
      {(imageCanvas) => (
        <div className="lm-header__back">
          <IconButton aria-label={intl.formatMessage({id:"iconButton.back"})}
                      className={"look-icon look-icon--small" + (isMobile ? "" : " look-icon--white")}
                      onClick={() => backButtonClick(imageCanvas)}>
            <ChevronLeftIcon/>
          </IconButton>
          <span className="lm-header__title" onClick={() => backButtonClick(imageCanvas)}>
            {title || <FormattedMessage id="wizard.header.categories"/>}
          </span>
        </div>
      )}
    </LookCanvasContext.Consumer>
  )
};

LookWizardHeaderTitleAndBackButton.propTypes = {
  title: PropTypes.any,
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  const {wizardActiveItem} = store.wizardState;
  return {
    isMobile,
    wizardActiveItem,
  };
};

const mapDispatchToProps = {
  setCanvasScale,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(LookWizardHeaderTitleAndBackButton)
  )
)
